import React from "react"
import { Page, PageBody, PageContent } from "core/layout/page"

const CodeRequired = ({ message }) => {
  return (
    <Page className="bg-warm-white-100">
      <PageBody className="container">
        <PageContent className="flex flex-col flex-auto h-full">
          <section className="flex flex-col mt-24 mb-8 mx-auto rounded-lg bg-white w-2/3 max-w-3xl min-w-full md:min-w-0">
            <p className="text-center text-gray-900 p-4">
              {message && message.length > 0
                ? message
                : "You are not authenticated."}
            </p>
          </section>
        </PageContent>
      </PageBody>
    </Page>
  )
}

export default CodeRequired
